import { forEachElement } from '../../common/utils/dom';
import { onDOMContentLoaded, onOnce } from '../../common/utils/domEvents';
import {
  getParameterValueFromRequest,
  isWebPlatform,
} from '../../common/utils/api';
import getFrontConfig from '../../common/getFrontConfig';

const FRONT_CONFIG = getFrontConfig();

const categorySlugRegExp = /.*\/([\w-]+)\/?(?:\?.*)?$/;
const productUrlRegeExp = /\/([\w\-%]*-)?(\w+\.\w+)(\.html)$/g;

const HANDLER_NAME_SHOW_CATEGORY = 'jsShowCategory';
const HANDLER_NAME_SHOW_PRODUCT = 'jsShowProduct';
const HANDLER_NAME_ADD_TO_BAG = 'addToBag';
const HANDLER_NAME_EDIT_CUSTOMIZER = 'jsEditCustomizer';

function findCategoryByName(categoryName) {
  if (window.menuData[categoryName]) {
    return window.menuData[categoryName];
  }
  return null;
}

function getCategoryIdByName(categoryName) {
  if (!window.menuData) return false;
  const category = findCategoryByName(categoryName);
  if (!category) return false;
  return category;
}

function getCategoryIdByUrl(url) {
  const cleanCategoryName = getCleanCategoryName(url);
  if (!cleanCategoryName) return null;
  return getCategoryIdByName(cleanCategoryName);
}

function categoryExists(categoryName) {
  const categoryId = getCategoryIdByName(categoryName);
  return categoryId !== false && categoryId !== null;
}

function getCleanCategoryName(url) {
  categorySlugRegExp.lastIndex = 0;
  const res = categorySlugRegExp.exec(url);
  return res && res.length > 1 ? res[1] : null;
}

function isCategoryUrl(url) {
  const cleanCategoryName = getCleanCategoryName(url);
  if (!cleanCategoryName) return false;
  if (!categoryExists(cleanCategoryName)) return false;
  return true;
}

function isProductUrl(url) {
  productUrlRegeExp.lastIndex = 0;
  const res = productUrlRegeExp.exec(url);
  return res && res.length > 1 ? res[1] : null;
}

function getProductInfoByUrl(url) {
  productUrlRegeExp.lastIndex = 0;
  const res = productUrlRegeExp.exec(url);
  const slug = res && res.length > 1 ? res[1] : null;
  const id = res && res.length > 2 ? res[2] : null;
  return { id, slug };
}

function getHandlerByPlatform(handlerName, param) {
  const platformParameterName = FRONT_CONFIG.apiConfig.PLATFORM_PARAMETER_NAME;
  const platform = getParameterValueFromRequest(platformParameterName);

  if (platform === FRONT_CONFIG.apiConfig.platforms.APP_IOS) {
    if (
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined'
    ) {
      if (
        handlerName === HANDLER_NAME_SHOW_CATEGORY &&
        typeof window.webkit.messageHandlers.jsShowCategory !== 'undefined'
      ) {
        window.webkit.messageHandlers.jsShowCategory.postMessage(param);
      }
      if (
        handlerName === HANDLER_NAME_SHOW_PRODUCT &&
        typeof window.webkit.messageHandlers.jsShowProduct !== 'undefined'
      ) {
        window.webkit.messageHandlers.jsShowProduct.postMessage(param);
      }
      if (
        handlerName === HANDLER_NAME_ADD_TO_BAG &&
        typeof window.webkit.messageHandlers.addToBag !== 'undefined'
      ) {
        window.webkit.messageHandlers.addToBag.postMessage(param);
      }
      if (
        handlerName === HANDLER_NAME_EDIT_CUSTOMIZER &&
        typeof window.webkit.messageHandlers.jsEditCustomizer !== 'undefined'
      ) {
        window.webkit.messageHandlers.jsEditCustomizer.postMessage(param);
      }
    }
  }

  if (
    platform === FRONT_CONFIG.apiConfig.platforms.APP_ANDROID &&
    typeof JSBridge !== 'undefined'
  ) {
    if (handlerName === HANDLER_NAME_SHOW_CATEGORY) {
      JSBridge.jsShowCategory(param);
    }
    if (handlerName === HANDLER_NAME_SHOW_PRODUCT) {
      JSBridge.jsShowProduct(param);
    }
    if (handlerName === HANDLER_NAME_ADD_TO_BAG) {
      JSBridge.addToBag(param);
    }
    if (handlerName === HANDLER_NAME_EDIT_CUSTOMIZER) {
      JSBridge.jsEditCustomizer(param);
    }
  }
}

function showCategory(categoryId) {
  getHandlerByPlatform(HANDLER_NAME_SHOW_CATEGORY, categoryId);
}

function showProduct(productId) {
  getHandlerByPlatform(HANDLER_NAME_SHOW_PRODUCT, productId);
}

function onElementLinkClick(e) {
  const link = e.currentTarget.getAttribute('href');
  const { pathname } = new URL(link);
  if (isProductUrl(pathname)) {
    e.preventDefault();
    const { id } = getProductInfoByUrl(pathname);
    showProduct(id);
    return;
  }
  if (isCategoryUrl(pathname)) {
    e.preventDefault();
    const id = getCategoryIdByUrl(pathname);
    showCategory(id);
  }
}

function addDeviceCodeParamToLink(elementLink) {
  const elementURL = new URL(elementLink.getAttribute('href'));

  const platformParameterName = FRONT_CONFIG.apiConfig.PLATFORM_PARAMETER_NAME;
  const platform = getParameterValueFromRequest(platformParameterName);
  if (!isWebPlatform(platform)) {
    elementURL.searchParams.set(platformParameterName, platform);
    elementLink.setAttribute('href', elementURL.toString());
  }
}

let elementsLink;
export default function init() {
  onDOMContentLoaded(() => {
    elementsLink = document.querySelectorAll(
      '.the-home__modules a:not([href=""])'
    );
    forEachElement(elementsLink, (elementLink) => {
      addDeviceCodeParamToLink(elementLink);
      elementLink.addEventListener('click', onElementLinkClick);
    });
  });
  onOnce(window, 'beforeunload', () => {
    if (!elementsLink) return;
    forEachElement(elementsLink, (elementLink) => {
      elementLink.removeEventListener('click', onElementLinkClick);
    });
  });
}

export function addToCart(pidsObj) {
  const pidsObjSerialized = `pidsObj=${JSON.stringify(pidsObj)}`;
  getHandlerByPlatform(HANDLER_NAME_ADD_TO_BAG, pidsObjSerialized);
}

export function editCustomizer(customizerId) {
  getHandlerByPlatform(HANDLER_NAME_EDIT_CUSTOMIZER, customizerId);
}

init();
